import { changePassword } from './states';

export const services = {
  changePassword,
};
